import * as orderConstants from './orderConstants';


export const onOrderLoaded = order => {

    return {
        payload: order,
        type: orderConstants.ACTION_ORDER_LOADED
    };
};


export const onOrderSummaryLoaded = orderSummary => {

    return {
        payload: orderSummary,
        type: orderConstants.ACTION_ORDER_SUMMARY_LOADED
    };
};
